import { useAppSelector } from '../../app/hooks';
import { selectFormContext, selectFormSchema } from '../../app/slices/form.slice';
import styles from '../../assets/css/form.module.css';
import { Form } from '../../fxfs';
import { FormContext } from './FormContext';
import { SubmitButton } from './SubmitButton';
import { useForm } from './useForm';
import { Box } from '@mui/material';
import { selectCurrentSessionState } from '../../app/slices/session.slice';
import { ConsumerInputNeededState } from '../../types/session';
import { usePolling } from '../redirection/usePolling';
import useCustomization from '../../hooks/useCustomization';
import { selectPreviousStep } from '../../app/slices/step.slice';
import HyperlinkCustomization from '../customizations/HyperlinkCustomization';

const FormStep = () => {
	const schema = useAppSelector(selectFormSchema)!;
	const context = useAppSelector(selectFormContext)!;
	const state = useAppSelector(selectCurrentSessionState) as unknown as ConsumerInputNeededState & {
		polling?: boolean;
	};

	const previousStep = useAppSelector(selectPreviousStep)!;
	const customization = useCustomization('FORWARDING_PAGE_SUBTITLE');

	usePolling();

	const { onChange, onValidationChange, onSubmit, submitting, isSubmitDisabled } = useForm(schema);

	const isPreviousStepBankSelection = previousStep === 'BANK_SELECTION';
	return (
		<Box id="form-step" key={schema.form_identifier} className={`form-container ${styles['form-container']}`}>
			<FormContext context={context} />
			<Form form={schema} onChange={onChange} onValidationChange={onValidationChange} />
			{!state.polling && <SubmitButton onSubmit={onSubmit} submitting={submitting} disabled={isSubmitDisabled} />}
			{isPreviousStepBankSelection && customization && (
				<Box sx={customizationContainerSX}>
					<HyperlinkCustomization content={customization} />
				</Box>
			)}
		</Box>
	);
};

export default FormStep;

const customizationContainerSX = {
	w: '100%',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	textAlign: 'center',
	boxSizing: 'border-box',
	color: 'rgb(14, 14, 15)',
	opacity: 0.7,
	fontWeight: 300
};
